var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","height":"100%"},attrs:{"element-loading-text":_vm.ssoLoginMsg}})
}
var staticRenderFns = []

export { render, staticRenderFns }